import { ref } from 'vue';

// Per-listing sort, same read/write shape as the VOD grid/list view keys.
// An unknown stored value falls back to that listing's default.
export function usePersistedSort(storageKey, options, fallback) {
  const allowed = Array.isArray(options) ? options : [];
  let stored = null;
  try {
    stored = localStorage.getItem(storageKey);
  } catch (e) { /* privacy mode */ }
  const sortBy = ref(allowed.includes(stored) ? stored : fallback);
  const setSort = (value) => {
    if (!allowed.includes(value)) return;
    sortBy.value = value;
    try {
      localStorage.setItem(storageKey, value);
    } catch (e) { /* quota / privacy mode */ }
  };
  return { sortBy, setSort };
}

export const DATE_NAME_SORT = ['Newest', 'Oldest', 'A to Z', 'Z to A'];
export const NAME_SORT = ['A to Z', 'Z to A'];
